import { useSearchParams } from 'next/navigation';
import { useContext, useEffect } from 'react';
import { useIntl } from 'react-intl';

import AuthForm from '@/components/authForm/AuthForm';
import googleMessages from '@/components/authForm/GoogleAuthButton/messages';
import { useAuthPrompt } from '@/context/auth/AuthPromptProvider';
import { useFreeTrial } from '@/hooks/purchase/useFreeTrial';
import { useUserState } from '@/hooks/store';
import genericMessages from '@/messages/messages';
import redirect from '@/utils/legacy/redirect';

import AnimatedScreenWrapper from '../../Components/AnimatedScreenWrapper';
import { PreSignupFlowContext } from '../../PreSignupProvider';
import messages from './messages';
import { Heading, Wrapper } from './styles';

const AccountSetup = () => {
	const { formatMessage } = useIntl();
	const user = useUserState();
	const { authPrompt } = useAuthPrompt();
	const searchParams = useSearchParams();
	const isSimplifiedFTUETest = searchParams?.get('utm_content')?.includes('_ft-sf') || false;

	const { activeFlowKey, nextScreen } = useContext(PreSignupFlowContext);
	const userCanTrial = useFreeTrial();

	useEffect(() => {
		if (user) {
			if (!userCanTrial) {
				redirect('/meditate');
				return;
			}

			nextScreen();
		}
	}, [userCanTrial, nextScreen, user]);

	const getHeading = () => {
		if (authPrompt === 'login') {
			return formatMessage(genericMessages.loginTitle);
		}

		if (isSimplifiedFTUETest) {
			return formatMessage(genericMessages.accountInfoSimplifiedFTUETitle, {
				pagebreak: <br />,
			});
		}

		return formatMessage(messages.signupTitle);
	};

	return (
		<AnimatedScreenWrapper isExiting={false}>
			<Wrapper>
				<Heading>{getHeading()}</Heading>
				<AuthForm
					customEventProps={{
						active_flow: activeFlowKey,
					}}
					facebookButtonText={
						authPrompt === 'signup'
							? formatMessage(genericMessages.continueFacebookSignupMessage)
							: formatMessage(genericMessages.facebookSignInMessage)
					}
					googleButtonText={
						authPrompt === 'signup'
							? formatMessage(googleMessages.continueCta)
							: formatMessage(googleMessages.signInCta)
					}
				/>
			</Wrapper>
		</AnimatedScreenWrapper>
	);
};

export default AccountSetup;
